<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="analysisTemplates">
      <div slot="toolbar">
        <el-button type="primary" @click="$refs.editAnalysisTemplate.open(0)">新建</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="名称">
            <el-input v-model.trim="filter.itemContent" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="itemName" align="center" label="名称"/>
      <el-table-column prop="itemContent" align="center" label="内容"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="120px">
        <template slot-scope="scope">
          <el-button type="primary" @click="$refs.editAnalysisTemplate.open(scope.row)">编辑</el-button>
          <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <analysis-template-edit ref="editAnalysisTemplate" @save-success="getList(1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import AnalysisTemplateEdit from "@/views/afterSalesManagement/Maintain/AnalysisTemplateEdit";
  export default {
    name: "AnalysisTemplateList",
    components: {AnalysisTemplateEdit, VmTable,VmSearch},
    data() {
      return {
        idList: "",
        exportLoading: false,
        filter: {
          itemContent: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","analysisTemplates",row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>

<style scoped>

</style>
